
import React from 'react';
import User from '../models/User';
import authService from '../services/AuthService';
import DOMService from '../services/DOMService';
import EntityManager from '../services/EntityManager';
import SessionService from '../services/SessionService';
import { RouteComponentProps, withRouter } from 'react-router';

export interface entrustTiers {
  firstname: string
  lastname: string
  phone: string
}

export interface ISessionBlocState {
  user: User | undefined
  logged: boolean
  theme: string
}

export interface ISessionBlocConsumer extends ISessionBlocState {

}

export const Context = React.createContext({})

export let sessionBloc: SessionBloc

class SessionBloc extends React.Component<RouteComponentProps, ISessionBlocState> {


  constructor(props: any) {
    super(props)
    sessionBloc = this

    this.state = {
      user: null,
      logged: false,
      theme: localStorage.getItem("theme") || "theme--default"
    }

  }

  get user() { return this.state.user }

  async init() {
    if (this.hasToken()) await this.me()
  }

  isAdmin() {
    return this.user.isAdmin;
  }

  isNationalResponsible() {
    return this.user.role.key === "user_role_national_responsible";
  }

  isManager() {
    return this.user.isManager || this.user.isAdmin;
  }

  isCustomer() {
    return this.user.isCustomer;
  }

  isAdminOrNationalResponsible(){
    return this.isAdmin() || this.user.role.key === "user_role_national_responsible";
  }

  isAdminOrResponsible() {
    return this.isManager() || this.user.role.key === "user_role_responsible" || this.user.role.key === "user_role_national_responsible";
  }

  isAdminOrResponsibleNational() {
    return this.isManager() || this.user.role.key === "user_role_national_responsible";
  }

  isAdminOrOrdonnanceur() {
    return this.isManager() || this.user.role.key === "user_role_ordonnanceur";
  }

  isOrdonnanceur() {
    return this.user.role.key === "user_role_ordonnanceur";
  }

  isSecretary() {
    return this.user.role.key === "user_role_secretaire";
  }

  isWorker() {
    return this.user.role.key === "user_role_worker";
  }

  isCoordinateur() {
    return this.user.role.key === "user_role_coordinateur";
  }

  /** Création / édition de profils utilisateurs (pas la suppression). */
  canManageUsers() {
    return this.isAdminOrResponsibleNational() || this.isCoordinateur();
  }

  goToModule(module: string) {
    localStorage.setItem("module", module)
  }

  public async me() {
    let response = await authService.usersManager.me();
    this.setSessionData(response.model);
    if (!response.ok) this.deleteToken();
    return true;
  }

  public hasToken() {
    return SessionService.getToken() !== null;
  }

  public isAuthenticated(): boolean {
    return !!this.state.user;
  }

  public isAuthorized(role: any): boolean {
    return this.isAuthenticated() && (role === "all")
  }
  public storeToken(token: string) {
    SessionService.setCookie(SessionService.cookieName, token, 30);
  }

  logged() {
    return !!this.state.user;
  }

  public deleteToken(): void {
    SessionService.eraseCookie(SessionService.cookieName)
    this.setState({user: null});
  }

  logout() {
    authService.logout();
    this.setState({logged: false, user: null});
    DOMService.setToaster("Nous espérons vous revoir bientôt 😊")
  }

  public getUserId = () => this.state.user?.id;

  public setSessionData(user: User): Promise<any> {
    return new Promise<any>((resolve) => {
      this.setState({user, logged: true}, () => resolve(true));
    })
  }

  public setUser(user: User) {
    this.setState({user});
  }

  switchTheme = () => {
    let theme: any = this.state.theme === "theme--default" ? "theme--dark" : "theme--default"
    localStorage.setItem("theme", theme);
    this.setState({theme})
  }

  updateUser(attr, value) {
    this.user[attr] = value;
    EntityManager.update<User>(this.state.user, {only: [attr]});
  }

  push(url, state?) {
    this.props.history.push(url, state)
  }

  routeState(): any {
    return this.props.location.state;
  }

  pop() {
    this.props.history.goBack()
  }

  public render() {
    return (
      <Context.Provider value={this.state}>
        {this.props.children}
      </Context.Provider>
    )
  }
}

export default withRouter(SessionBloc as any);

export function consumeSessionBloc(Component) {

  return class C extends React.Component<any> {

    render() {
      return (
        <Context.Consumer>
          { (context) => (
            <Component {...this.props } {...context}/>
          )}
        </Context.Consumer>
      )
    }
  }
}
